module.exports = __webpack_public_path__ + "img/analyze-data-animation.d56597ee.svg";